// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  border-radius: 0 !important;
}

:host {
  display: block;
}

.dialog-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: min(680px, 100%);
  min-height: min(100px, 40vh);
}

.dialog-hint {
  margin: 0;
  font-size: 0.85rem;
  color: #666;
}

.action-error {
  color: #a94442;
  font-size: 0.8rem;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/job-request-details/formulation-iterations/formulation-barcode-dialog/formulation-barcode-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,2BAAA;EACA,4BAAA;AACF;;AAEA;EACE,SAAA;EACA,kBAAA;EACA,WAAA;AACF;;AAEA;EACE,cAAA;EACA,iBAAA;AACF","sourcesContent":[":host ::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {\n  border-radius: 0 !important;\n}\n\n:host {\n  display: block;\n}\n\n.dialog-content {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-width: min(680px, 100%);\n  min-height: min(100px, 40vh);\n}\n\n.dialog-hint {\n  margin: 0;\n  font-size: 0.85rem;\n  color: #666;\n}\n\n.action-error {\n  color: #a94442;\n  font-size: 0.8rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
